import React, { FC, ReactNode } from "react";

interface ICheckboxFieldProps {
  checked: boolean;
  onChange(): void;
  label: ReactNode;
}

export const CheckboxField: FC<ICheckboxFieldProps> = ({
  checked,
  onChange,
  label,
}) => {
  return (
    <div
      className="checkbox-field"
      onClick={(e) => {
        if ((e.target as HTMLElement).tagName !== "A") {
          onChange();
        }
      }}
      role="checkbox"
      aria-checked={checked}
    >
      <div className={`checkbox ${checked ? "checked" : ""}`} />
      <span>{label}</span>
    </div>
  );
};
